import React from 'react';
import historyImage from '../../../assets/HistoryImage12.jpg';
import './HistoryVideo1Auto.css';

const HistoryVideo1Auto = () => {
  return ( 
    <div className="video-container">
      <div className="History-containers">History Begins</div>

      <img src={historyImage} alt="History Image" className="fullscreen-image" />
    </div>
  );
};

export default HistoryVideo1Auto;
